'use client';
import React from 'react';
import styled from '@benzinga/themetron';
import { Button } from '@benzinga/core-ui';

export interface ScreenerTableEdgeCTAProps {
  rowSpan: number;
  colSpan: number;
}

export const ScreenerTableEdgeCTA: React.FC<ScreenerTableEdgeCTAProps> = ({ colSpan, rowSpan }) => {
  return (
    <ScreenerTableEdgeCTAWrap className="edge-promo" colSpan={colSpan} rowSpan={rowSpan}>
      <div className="flex flex-col edge-wrap justify-between">
        <div className="edge-logo">
          <img alt="Bz Edge" src="https://cdnwp-s3.benzinga.com/wp-content/uploads/2024/08/23110537/bz-edge-logo.png" />
        </div>
        <div>
          <h3 className="mb-4">Upgrade to Benzinga Edge to get this data and more!</h3>
          <p>
            Benzinga Edge Brings You Premium Content, Tools, and Analytics Designed to Empower Your Investing Journey
          </p>
        </div>
        <div className="edge-buy-now">
          <Button
            as="a"
            className="text-white"
            href="https://www.benzinga.com/premium/ideas/benzinga-edge-checkout/?t=be8be9we6ja3mo2be24&utm_source=edge-screener-table-benzinga-edge"
            target="_blank"
            variant="flat-blue"
          >
            Upgrade to <i>EDGE</i>
          </Button>
          <Button
            as="a"
            href="https://www.benzinga.com/premium/ideas/benzinga-edge-checkout/?t=be8be9we6ja3mo2be24&utm_source=edge-screener-table-benzinga-edge#edge-pricing-table"
            target="_blank"
            variant="flat-light-blue"
          >
            Learn More
          </Button>
        </div>
      </div>
    </ScreenerTableEdgeCTAWrap>
  );
};

const ScreenerTableEdgeCTAWrap = styled.td`
  min-width: 240px;
  background: #e1ebfa;
  .edge-wrap {
    height: 100%;
    padding: 20px 6px;
    text-align: center;
    .edge-logo {
      margin: 0 auto;
      width: 85%;
    }
    .edge-buy-now {
      a {
        display: block;
        width: 100%;
        margin-bottom: 0.8rem;
      }
    }
  }
`;
